module.exports = __webpack_public_path__ + "img/dk.33bba71c.svg";